<template>
  <div class="winners-2021">
    <MainBg />
    <img
      class="winners-2021__logo"
      src="~@/assets/img/logo.png"
      alt="Red Bull River Runes"
    />
    <h1 class="winners-2021__title">Победители</h1>
    <h2 class="winners-2021__subtitle">Турнира Red Bull River Runes 2021</h2>
    <Winners2021Section />
  </div>
</template>

<script>
import Winners2021Section from "@/components/winners/2021/Winners2021Section";
import MainBg from "@/components/common/MainBg";

export default {
  name: "Winners2021",
  components: {
    MainBg,
    Winners2021Section
  }
};
</script>

<style lang="scss">
.winners-2021 {
  font-family: "Montserrat";
  padding: 50px 0 50px;
  position: relative;
  z-index: 1;
  .orange {
    color: #fbc33e;
  }

  &__logo {
    display: block;
    margin: 0 auto 50px;
    height: 170px;
  }

  &__subtitle,
  &__title {
    text-align: center;
    line-height: 1.15;
    padding: 0 15px;
  }

  &__title {
    font-weight: 900;
    font-size: 80px;
    text-transform: uppercase;
    color: #fbc33e;
    text-shadow: 0px 10px 50px #ff3d00;
    margin-bottom: 25px;
  }

  &__subtitle {
    font-weight: bold;
    font-size: 40px;
    text-shadow: 0px 4px 20px #fb553e;
    margin-bottom: 70px;
  }

  @include breakpoint("sm-and-down") {
    &__title {
      font-size: 55px;
    }
    &__subtitle {
      font-size: 30px;
    }
  }

  @include breakpoint("xs-only") {
    &__title {
      font-size: 38px;
    }
    &__subtitle {
      font-size: 22px;
    }
  }
}

.winners-2021-title {
  font-family: "Montserrat";
  font-weight: 900;
  font-size: 52px;

  text-align: center;
  letter-spacing: 0.02em;
  color: #fbc33e;
  line-height: 1.15;
  text-transform: uppercase;

  margin-bottom: 0.6em;

  @include breakpoint("xs-only") {
    font-size: 26px;
  }
}
</style>
